const EpStore = new MenuConstraintsUtility.Store({
  apiUrl: MIDDLEWARE_API_URL,
  calendarWeeksCutOff: 10,
});

const COLLECTIONS_RP = 100;
const CALENDAR_HIGHLIGHT_COLOR = '#153A36';
var zipCodeCheckContent = null;
var addressSupportContent = null;

Shopify.onCartUpdate = function() {};

function handleAddProduct(product, event) {
  try {
    EpStore.addProduct(product);
  } catch (error) {
    if ('code' in error && error.code > 0) {
      showMessage('The product was not added', error.message);
    } else {
      showMessage('Oops!', 'Something went wrong. Please try again.');
    }

    event.preventDefault();
  }
}

function bindToCartActionClick() {
  $('.add-to-cart-button-action').on('click', function(event) {
    var productId = $(this).data('product-id');
    var tags = $(this).data('product-tags');
    var title = $(this).data('product-title');

    if (!productId) {
      event.preventDefault();
      return;
    }

    const productTags = (tags || '').split(',');

    handleAddProduct({ id: productId, tags: productTags, title: title }, event);
  });
}

function validateDisplayedProducts() {
  // Check if every product block in the page is available to be displayed based on the selected date
  $('[data-tags]').each(function(index) {
    var tags = $(this).data('tags').split(',');
    if (!EpStore.isProductVisibleInMenu(tags)) {
      $(this).remove();
    } else {
      $(this).show();
    }
  });
}

function showMessage(title, message, callbacks) {
  var content = $("#ep-alert-container").html();
  content = content.replace('[title]', title);
  content = content.replace('[message]', message);
  $.fancybox.open({
      padding: 20,
      overlayOpacity:	0.3,
      overlayColor: '#222222',
      beforeLoad: function(){
        callbacks && callbacks.beforeLoad ? callbacks.beforeLoad() : null;
      },
      content: content,
      afterClose : function(){
        callbacks && callbacks.afterClose ? callbacks.afterClose() : null;
      }
  });
}

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function validateZipCode(zip) {
  return !isNaN(Number(zip).valueOf()) && zip.length === 5;
}

function handleCloseZipModals() {
    $.fancybox.close();
    localStorage.setItem('ep-address-support-requested', true);
    $('.modal-backdrop').hide();
}

function bindOnCloseZipCodePopups() {
  $(".ep-popup-close").on('click', function(){
    handleCloseZipModals();
  });
}

function showZipCodeCheck() {
  showModal(zipCodeCheckContent, function(){
    var button = $(".ep-popup-zipcode button");
    var input = $(".ep-popup-zipcode input");

    input.keyup(function(e){
      var zipCode = input.val();
      if (validateZipCode(zipCode)) {
        button.removeAttr('disabled');
      }
      else {
        button.attr('disabled', true);
      }
    });

    button.on('click', function(){
      var zipCode = input.val();
      EpStore.setZipcode(zipCode)
        .then(function(response){
          showZipCodeCheckSuccess();
        })
        .catch(function(error){
          showAddressSupportRequest(zipCode)
        }
      );
    });
  });
}

function showZipCodeCheckSuccess() {
  showModal($("#ep-popup-zipcode-success").html(), function(){
    $(".fancybox-skin").css('padding-left', 0);
    $(".fancybox-skin").css('padding-right', 0);
  });
}

function showAddressSupportRequest(zipCode) {
  showModal(addressSupportContent, function(){
    var button = $(".ep-popup-address-support-request button");
    var input = $(".ep-popup-address-support-request input");

    input.keyup(function(e){
      if (validateEmail(input.val())) {
        button.removeAttr('disabled');
      }
      else {
        button.attr('disabled', true);
      }
    });

    button.on('click', function(){
      $.ajax({
        dataType: "json",
        accepts: {
            text: "application/json"
        },
        type: "POST",
        url: MIDDLEWARE_API_URL + '/address-support-request',
        data: {
          email: input.val(),
          address: "Zip code: " + zipCode
        },
        success: function() {
          localStorage.setItem('ep-address-support-requested', true);
          showAddressSupportRequestSuccess();
        },
        statusCode: {
          429: function() {
            alert('You have exceeded the allowed calls for this service. Try again later.');
          }
        }
      });
    });
  });
}

function showAddressSupportRequestSuccess() {
  showModal($("#ep-popup-address-support-request-success").html(), function(){
    $(".fancybox-skin").css('padding-left', 0);
    $(".fancybox-skin").css('padding-right', 0);
  });
}

function showModal(content, afterShow) {
  $.fancybox.open({
      autoSize: true,
      fitToView: true,
      content: content,
      hideScroll: true,
      paddingLeft: '0px',
      paddingRight: '0px',
      afterClose: function() {
        handleCloseZipModals();
      },
      afterShow: function() {
        // Fix known issues about outside clicking and modal overlay not displaying
        $('#overlay-modal').modal();
        $('.modal-backdrop').show();
        $(".modal-backdrop").off('click');
        $(".modal-backdrop").on('click', handleCloseZipModals);

        bindOnCloseZipCodePopups();

        if (afterShow) {
          afterShow();
        }
      }
  });
}

function forceZipCodeCheck() {
  localStorage.removeItem('ep-address-support-requested');
  showZipCodeCheck();
}

function cleanIndexedCollectionTitle(element) {
    $(element).text($(element).text().replace(/(\d*\.\s)/, '').trim());
    $(element).removeClass('ep-collection-titles');
}

function bindMenuCollectionDisplay() {
  EpStore.getMenuList().then(function(items){
    const availableCollectionIds = items.map(function(item){ return item.handle});

    // Manage home collection grid items
    $('.ep-home-collection').each(function(i, item){
      const handle = $(item).attr('data-collection-handle');
      if (!availableCollectionIds.includes(handle)) {
        $(item).parent().hide();
      }
      else{
        $(item).show();
      }
    });

    $('.ep-collection-titles').each(function(i, item){
      cleanIndexedCollectionTitle(item);
    });

    // Manage main navegation links
    $('.ep-menu-collection').each(function(i, item){
      const handle = $(item).attr('data-collection-handle');
      if (!availableCollectionIds.includes(handle)) {
        $(item).remove();
      }
    });
  });
}

function getPaginationIcons(type) {
  if (type === 'prev') {
    return '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="prev-icon icon" viewBox="0 0 40 30" enable-background="new 0 0 40 30" xml:space="preserve" aria-disabled="true" display="block"><path d="M15.3 19.2c0 0 0 0-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0.2-0.2 0.4-0.2 0.7 0 0.2 0.1 0.5 0.2 0.7 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0.1l3.8 3.9c0.4 0.4 1.1 0.4 1.5 0 0.4-0.4 0.4-1.1 0-1.6l-2-2h15.3c0.6 0 1.1-0.5 1.1-1.1 0-0.6-0.5-1.1-1.1-1.1H18.6l2-2c0.4-0.4 0.4-1.1 0-1.6-0.4-0.4-1.1-0.4-1.5 0l-3.8 3.9C15.3 19.2 15.3 19.2 15.3 19.2z"></path></svg>';
  }
  return '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="next-icon icon" viewBox="0 0 40 30" enable-background="new 0 0 40 30" xml:space="preserve" aria-disabled="false" display="block"><path d="M34.7 19.2L30.9 15.3c-0.4-0.4-1.1-0.4-1.5 0-0.4 0.4-0.4 1.1 0 1.6l2 2H16.1c-0.6 0-1.1 0.5-1.1 1.1 0 0.6 0.5 1.1 1.1 1.1h15.3l-2 2c-0.4 0.4-0.4 1.1 0 1.6 0.4 0.4 1.1 0.4 1.5 0l3.8-3.9c0 0 0 0 0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.2 0.2-0.4 0.2-0.7 0-0.2-0.1-0.5-0.2-0.7 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1-0.1C34.7 19.2 34.7 19.2 34.7 19.2z"></path></svg>';
}

/**
 * Get the value for the given query string name
 * @param {string} name   Query parameter name
 * @returns {string|null}
 */
function getQueryValueFor(name) {
  var url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return null;
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * Build the paginator comp
 * @param {string} selector              ID of the DOM selector
 * @param {number} collectionsLength     Size of the collection list
 */
function buildPaginator(selector, collectionsLength) {
  $(selector).html('');

  if (collectionsLength > COLLECTIONS_RP) {
    var queryPage = getQueryValueFor('page');
    var pages = parseInt(collectionsLength/COLLECTIONS_RP);
    if (collectionsLength/COLLECTIONS_RP > pages) {
      pages++;
    }

    var currentPage = queryPage ? parseInt(queryPage) : 1;
    var paginatorHtml = '<ul class="pagination pull-right">';

    if (currentPage > 1) {
      var prevPage = parseInt(currentPage - 1);
      paginatorHtml += '<li class="pagination_previous">' +
                          `<a href="/collections?page=${prevPage}" title="« Previous">${getPaginationIcons('prev')}</a>`
                      '</li>';
    }

    for (var i = 0; i < pages; i++) {
      var classProp = currentPage === (i + 1) ? 'class="active"' : '';
      var pageText = parseInt(i + 1);
      paginatorHtml += `<li ${classProp}><a href="/collections?page=${pageText}" title="${pageText}">${pageText}</a></li>`
    }

    if (currentPage < pages) {
      var nextPage = parseInt(currentPage + 1);
      paginatorHtml += '<li class="pagination_next">' +
                          `<a href="/collections?page=${nextPage}" title="Next »">${getPaginationIcons('next')}</a>`
                      '</li>';
    }

    paginatorHtml += '</ul>';

    $(selector).html(paginatorHtml);
  }
}

/**
 * Render the pagination comp
 * @param {string} selector  ID of the DOM selector
 */
function renderPaginationFromEpCollections(selector) {
  if (EpStore.menuCollections.length === 0) {
    EpStore.getMenuList().then(function(items)
    {
        buildPaginator(selector, items.length);
    });
  }
  else{
    buildPaginator(selector, EpStore.menuCollections.length);
  }
}

function getURLQueryParams(){
    var vars = {}, hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars[hash[0]] = hash[1];
    }
    return vars;
}

function boot() {
  zipCodeCheckContent = $("#ep-popup-zipcode").html();
  addressSupportContent = $("#ep-popup-address-support-request").html();
  $("#ep-popup-zipcode").remove();
  $("#ep-popup-address-support-request").remove();

  var requireZipQueryVar = 'require-zip-code';
  var zipcode = EpStore.getZipcode();
  var alreadyHandled = localStorage.getItem('ep-address-support-requested') !== null;
  var query = getURLQueryParams();

  if ((!zipcode && !alreadyHandled) || query.hasOwnProperty(requireZipQueryVar)) {
    showZipCodeCheck()
  }
}

$(function() {
  boot();
  bindMenuCollectionDisplay();
  validateDisplayedProducts();
  bindToCartActionClick();
});
